import ssct from "../abis/development/tokens/ssctToken";

export default {
  name: "SSCT",
  abi: ssct.abi,
  contractAddress: "0x7f17001172667a3351f3a11df6ed865578df2295",
  decimals: 18,
};
